import React, { useContext, useEffect, useState } from 'react'


import { Order } from '../../Models/Order'
import { getOrdersAdmin } from '../../Api/Orders'
import OrderAdminTable from '../Tables/OrderAdminTable'
import { PromiseSesionContext } from '../../Machines/ErrorMachine'



interface Props{
   loading:boolean
   setLoading:React.Dispatch<React.SetStateAction<boolean>>
   status:string
   setTotal?: React.Dispatch<React.SetStateAction<number>>
}

const AdminOrderListTable = ({loading, setLoading, status, setTotal}:Props) => {
  const [allOrders, setAllOrders] = React.useState<Order[]>([]);
  const {sendError} = useContext(PromiseSesionContext);


  //paginate
  const [page, setPage] = useState<number>(1)
  const [limitPage, setLimitPage] = useState<number>(5)

  const [totalPage, setTotalPage] = useState<number>(0)
  const [totalElements, setTotalElements] = useState<number>(0)

    const getProducts = async ()=>{
        try{
        setLoading(true);
        const response =  await getOrdersAdmin(page, limitPage, status)
        if(response.total!== totalElements){
          setPage(1)
        }
        setAllOrders(response.orders)
        // setFilteredProducts(response.products); 
        setTotalPage(response.last_page)
        setTotalElements(response.total)
        if(setTotal){
          setTotal(response.total)
        }
        setLoading(false);
        }
        catch(error){
        setLoading(false);
        sendError({type: "ERROR", data:{message:"Error al cargar las ordenes.", type:"error"}})

        }
    }

    useEffect(() => {
      getProducts()
    }, [status]);

  return (
    <OrderAdminTable
    onRefresh={()=>{getProducts()}}
    loading={loading}
    products={allOrders}
    current={page} pageSize={limitPage}
    total={totalElements}
    setPage={setPage} />
  )
}

export default AdminOrderListTable